// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stripe-card-container[data-v-329f5a4e]{padding:10px 12px;border:1px solid #ced4da;border-radius:4px;background-color:#fff;min-height:40px}.style-msg[data-v-329f5a4e]{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
